import { render } from "./StoreOrders.vue?vue&type=template&id=1b9c432c&scoped=true"
import script from "./StoreOrders.vue?vue&type=script&lang=js"
export * from "./StoreOrders.vue?vue&type=script&lang=js"

import "./StoreOrders.vue?vue&type=style&index=0&id=1b9c432c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9c432c"]])

export default __exports__